import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useFanPublicationStore } from "%/stores/fan-publication-store";
import SmartFeedEngine from "~/smart-feed/smart-feed-engine";
import { useGeneralStore } from "%/stores/general-store";

export const usePublishedStoryFeedStore = defineSmartFeedPiniaStore("published-story-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    metadata: {
      lastId: Number.MAX_SAFE_INTEGER,
      publicationId: useFanPublicationStore().publicationId,
      userId: useGeneralStore().userId,
    },
  }),
  getters: {
    feedUrl() {
      return `publication/${this.metadata.publicationId}/stories/published/smart-feed`;
    },
    smartFeedRequestGetParams() {
      return {
        last_id: this.metadata.lastId,
        user_id: this.metadata.userId,
      };
    },
  },
});
